module.exports = __webpack_public_path__ + "b4b9b0c99d50f3d707c6f95c16cfd680.svg";